import React, { memo, useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './ItemGameActive.module.less';
import { CONTEXT } from '../../../../config';
import Button from '../../../../components/Button/Button';
import androidImg from '../../../../static/game/bigAndroid.png';
import DLCImg from '../../../../static/game/bigDLC.png';
import { logging, logPostInfo } from '../../../../actions/log';
import { getSoftType } from '../../../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, topIndex, logInfo }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const history = useHistory();
  const [isHover, setIsHover] = useState(false); // 用来区分hover样式

  const formatPriceType3 = useCallback((num = '0') => {
    return parseFloat((num || '0')?.replace('¥', '').replace('￥', ''));
  }, []);

  const formatPrice = useCallback((num = '0') => {
    return `${parseFloat((parseInt(num) / 100).toFixed(2)) || 0}`;
  }, []);
  const formatPriceZK = useCallback((cu, or) => {
    let c = parseFloat(cu);
    let o = parseFloat(or);
    if (c && o) {
      return `${parseFloat((c / o).toFixed(2)) * 10 || 0}`;
    }
    return '';
  }, []);

  const indexTop = index => {
    switch (index) {
      case 0:
        return styles.top1;
      case 1:
        return styles.top2;
      case 2:
        return styles.top3;
      case 3:
        return styles.top4;
      case 4:
        return styles.top5;
    }
  };

  const handleLink = () => {
    const source = logInfo ? logInfo.source : 'SoftCard_err';
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          ...logInfo,
          softid: soft.androidType === '1' ? soft?.packageName : soft?.softID,
          versionCode: soft?.versionCode,
          softType: getSoftType(soft),
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
      }),
    );
    if (soft.androidType === '1') {
      history.push(
        `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo || '{}'}`,
      );
    } else {
      history.push(`${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}`);
    }
  };

  const handleMouseLeave = e => {
    setIsHover(false);
  };

  return (
    <div className={styles.card_item} onClick={handleLink}>
      <div
        className={`${styles.item_game_active} ${
          isHover && !soft?.resUrl ? `${styles.image_mouse_in}  ` : ''
        } ${!isHover && !soft?.resUrl ? styles.image_mouse_out : ''}`}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={handleMouseLeave}
        onMouseMove={() => setIsHover(true)}
      >
        <div className="item_game_mask" />
        <img
          className={`${styles.hover_img} item_game_bg`}
          src={
            isHover
              ? soft.resUrl ?? soft.ztImg ?? soft?.captureFileList?.[0]
              : soft.ztImg ?? soft?.captureFileList?.[0]
          }
        />
        <div className={`item_game_top ${indexTop(topIndex)}`} />
        <div className={`${styles.title_show}  item_game_content`}>
          <div className="content_left">
            <div className="left_title">
              <div className={` left_title_describe`}>{soft.softName}</div>
              {soft.androidType === '1' && <img className="left_title_a_icon" src={androidImg} />}
              {soft.installFileType === 1 && <img className="left_title_d_icon" src={DLCImg} />}
            </div>

            <div className="left_info">
              {isHover ? (
                <>
                  <div className="info_download">{soft.downloadCount}安装</div>
                </>
              ) : (
                <>
                  <div className="info_download">{soft.downloadCount}安装</div>
                </>
              )}
            </div>
          </div>
          <div className="content_right">
            {isHover ? (
              <div
                onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                <Button
                  soft={soft}
                  info={{
                    btnStyle: 'opacity',
                    className: styles.active_btn,
                    className_busing: styles.active_btn,
                    className_open: styles.active_btn,
                  }}
                  logInfo={{ ...logInfo, softId: soft.softID, softType: soft.softType }}
                />
              </div>
            ) : (
              <>
                {soft?.androidType === '3' && soft?.sourceInfo && soft?.sourceInfo?.sellInfo && (
                  <div>
                    {soft?.sourceInfo?.sellInfo?.discount && (
                      <div className="right_discount">
                        <div className="discount">{soft?.sourceInfo?.sellInfo?.discount} 折</div>
                      </div>
                    )}

                    {soft?.sourceInfo?.sellInfo?.currentPrice ===
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                      <>
                        {soft?.sourceInfo?.sellInfo?.currentPrice &&
                          !soft?.sourceInfo?.sellInfo?.originalPrice && (
                            <div className="right_price">
                              <div className="right_price_n">
                                ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                              </div>
                            </div>
                          )}
                        {!soft?.sourceInfo?.sellInfo?.currentPrice &&
                          soft?.sourceInfo?.sellInfo?.originalPrice && (
                            <div className="right_price">
                              <div className="right_price_n">
                                ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                              </div>
                            </div>
                          )}

                        {soft?.sourceInfo?.sellInfo?.currentPrice &&
                          soft?.sourceInfo?.sellInfo?.originalPrice && (
                            <div className="right_price">
                              <div className="right_price_n">
                                ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                              </div>
                            </div>
                          )}
                      </>
                    )}
                    {soft?.sourceInfo?.sellInfo?.currentPrice !==
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                      <>
                        {soft?.sourceInfo?.sellInfo?.currentPrice &&
                          !soft?.sourceInfo?.sellInfo?.originalPrice && (
                            <div className="right_price">
                              <div className="right_price_n">
                                ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                              </div>
                            </div>
                          )}
                        {!soft?.sourceInfo?.sellInfo?.currentPrice &&
                          soft?.sourceInfo?.sellInfo?.originalPrice && (
                            <div className="right_price">
                              <div className="right_price_n">
                                ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                              </div>
                            </div>
                          )}
                        {soft?.sourceInfo?.sellInfo?.currentPrice &&
                          soft?.sourceInfo?.sellInfo?.originalPrice && (
                            <>
                              <div className="right_price">
                                <div className={`right_price_n`}>
                                  ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                                </div>
                                <div className={`right_price_o`}>
                                  ¥{formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                                </div>
                              </div>
                            </>
                          )}
                      </>
                    )}
                  </div>
                )}

                {soft && soft.payType === 1 && (
                  <div>
                    {soft?.currentPrice &&
                      soft?.originalPrice &&
                      soft?.currentPrice !== soft?.originalPrice && (
                        <div className="right_discount">
                          <div className="discount">
                            {formatPriceZK(soft?.currentPrice, soft?.originalPrice)} 折
                          </div>
                        </div>
                      )}
                    {((!soft?.currentPrice && soft?.originalPrice) ||
                      (soft?.currentPrice && !soft?.originalPrice) ||
                      soft?.currentPrice === soft?.originalPrice) && (
                      <div className="right_price">
                        <div className={`right_price_n`}>
                          ¥{formatPrice(soft?.currentPrice || soft?.originalPrice)}
                        </div>
                      </div>
                    )}
                    {soft?.currentPrice &&
                      soft?.originalPrice &&
                      soft?.currentPrice !== soft?.originalPrice && (
                        <div className="right_price">
                          <div className={`right_price_n`}>¥{formatPrice(soft?.currentPrice)}</div>
                          <div className={`right_price_o`}>¥{formatPrice(soft?.originalPrice)}</div>
                        </div>
                      )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
